declare var Shopify: { currency: { active: string } }

const formatCentsToDollars = (cents: number) => {
  const currency = Shopify.currency.active || 'AUD'
  const dollars = cents / 100

  const formattedDollars = dollars.toLocaleString('en-AU', {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  })

  return `${formattedDollars} ${currency}`
}

const formatMoney = (cents: number) => {
  return `${(cents / 100).toLocaleString()} ${Shopify.currency.active}`
}

const formatDollars = (dollars: number) => {
  return `${(dollars).toLocaleString()} ${Shopify.currency.active}`
}

export { formatCentsToDollars, formatMoney, formatDollars }